import React from 'react'
import PropTypes from 'prop-types'
import ItemRow from '../../ItemRow'
import { useIntl } from 'react-intl'

const RelatedConnectorsRow = (props) => {
  const intl = useIntl()
  const {
    name,
    id,
    description,
    harnessName,
    onConnectorSelect,
    selectedConnectors,
  } = props

  return (
    <ItemRow
      name={name}
      inputName={name}
      value={id}
      onChange={() => onConnectorSelect(id)}
      isChecked={selectedConnectors?.includes(id)}
      description={description}
      isSelected={true}
    >
      {harnessName && (
        intl.formatMessage({ id: 'generic.harnessPrefix' }, { harnessName })
      )}
    </ItemRow>
  )
}

RelatedConnectorsRow.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  id: PropTypes.number.isRequired,
  onConnectorSelect: PropTypes.func.isRequired,
  selectedConnectors: PropTypes.array.isRequired,
}

export default RelatedConnectorsRow
